<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>初購入：{{ trialDays }}日</div>
    <div v-if="segmentLabel && segmentLabel.length > 0">
      顧客セグメント：{{ segmentLabel }}
    </div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * TigerC「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    trialDays: {
      type: Number,
      default: 365,
    },
    customerSegment: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    segmentLabel() {
      return this.customerSegment
        ? this.$store.state.labels.customerSegment[this.customerSegment]
        : ''
    },
  },
}
</script>
